import { cn } from '../../lib/cn';
import type { AIValidationRow } from '../../enterprisequality/framework';

type Props = { results?: AIValidationRow[] };

export function AIValidationPanel({ results = [] }: Props) {
  return (
    <div className="space-y-2">
      {results.map((r) => (
        <div key={r.check} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-sm font-medium">{r.check}</p>
              <p className="text-xs text-slate-500">{r.detail}</p>
            </div>
            <div className="text-right">
              <p className="text-sm font-semibold">{r.score}%</p>
              <span className={cn(
                'text-xs font-medium',
                r.status === 'passed' ? 'text-success-600' : 'text-error-600',
              )}>
                {r.status}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
